<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <RadioGroup :options="radioData" @radioChange="radioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <template #end>
        <el-form-item>
          <el-button type="success" @click="settle">批量结算</el-button>
        </el-form-item>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运单列表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showSelect="true" :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #edittime="params">
        {{ params.params.edittime ? params.params.edittime.slice(0, 10) : "-" }}
      </template>
      <template #open="params">
        <MySwitch :data="params.params" :activeValue="'2'" :inactiveValue="'1'" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'pshipperrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/carrier` },
        { name: "应付账款管理", path: `/finance/carrier` },
        { name: "运单列表" },
      ],
      wxtsList: [
        {
          name: '应收运费=公司运费-亏吨金额+补差金额'
        },
        {
          name: '应付运费=承运运费-亏吨金额'
        },
      ],
      radioData: [
        { label: "全部运单", value: 1 },
        { label: "普通运单", value: 3 },
        { label: "合同运单", value: 2 },
      ],
      formInline: {
        index: 1,
      },
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
        {
          label: "结算状态",
          keyName: "ispcustom",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '未结算', value: 1 },
            { label: '已结算', value: 2 },
          ],
        },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 130 },
        { keyName: "pcustomname", label: "承运公司", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 130 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 140 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "承运单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "承运金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', width: 110 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "nickname", label: "派单人", minwidth: 120 },
        { keyName: "open", label: "结算", slot: "open", minwidth: 120 },
      ],
      getTotalProperty: ['inton', 'unton', "kuiton", "kuitotal", "freight", "additional_fees", "compen", 'ys_freight', 'yf_freight', 'infreight'],
      baseParams: ['index', 'shipperid'],
    };
  },
  methods: {
    radioChange(v) {
      // console.log(v);
      this.formInline.index = v
      this.getList();
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const o = this.dataObjHandler(v)
          o.open = v.ispcustom + ''
          return o
        })
      }
      // console.log(this.tableData)
    },
    settle() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '请选择条目!',
        });
        return
      }
      let count = 0
      const arr = []
      this.selection.map(v => {
        count += Number(v.yf_freight)
        arr.push(v.id)
      })
      // console.log(this.selection)
      this.$confirm(`结算金额为${count}元？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.settleReq(arr);
      }).catch(() => { });
    },
    settleReq(delList) {
      let url = `pcustom/settlement`;
      const params = {
        // userid: this.user.id,
        delList,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    toggleDisplay({ id }) {
      let url = `pcustom/upsettled`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}

.main {
  /deep/ .el-form--inline {
    .item {
      margin-right: 10px;
    }
  }
}
</style>
